"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Slide_1 = __importDefault(require("./Slide/Slide"));
var main_1 = require("../../main");
/**
 * The Carousel component is used to cycle through sequential series of images with optional structured calls to action.
 * @child ./Slide/Slide.tsx
 */
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.prevItem = function () {
            _this.setAutoTimer();
            var prevItem = _this.state.counter - 1 < 0 ? react_1.Children.count(_this.props.children) - 1 : _this.state.counter - 1;
            _this.setSlide(prevItem);
        };
        _this.nextItem = function () {
            _this.setAutoTimer();
            var nextItem = _this.state.counter + 1 < react_1.Children.count(_this.props.children) ? _this.state.counter + 1 : 0;
            _this.setSlide(nextItem);
        };
        _this.setAutoTimer();
        _this.state = {
            counter: 0
        };
        return _this;
    }
    Carousel.prototype.componentWillUnmount = function () {
        clearTimeout(this.autoTimer);
    };
    Carousel.prototype.render = function () {
        var _this = this;
        var slides = this.getChildrenSlides();
        var theme = slides.length ? slides[this.state.counter].props.theme : 'light';
        var _a = this.props, height = _a.height, transitionTime = _a.transitionTime, className = _a.className, autoPlay = _a.autoPlay, rest = __rest(_a, ["height", "transitionTime", "className", "autoPlay"]);
        return (React.createElement("div", __assign({}, rest, { className: "ui carousel " + (className ? className : ''), style: { height: height }, onMouseEnter: function () { return clearTimeout(_this.autoTimer); }, onMouseLeave: function () { return _this.setAutoTimer(); } }),
            React.createElement("div", { className: 'carousel-core ' + theme },
                React.createElement("div", { className: "carousel-prev", onClick: this.prevItem },
                    React.createElement(main_1.Icon, { root: "common", name: "caret-left", className: "arrow", size: "small" })),
                this.renderItems(),
                React.createElement("div", { className: "carousel-next", onClick: this.nextItem },
                    React.createElement(main_1.Icon, { root: "common", name: "caret-right", className: "arrow", size: "small" })),
                React.createElement("ul", { className: "slide-markers" }, this.genSliderMarkers()))));
    };
    Carousel.prototype.setAutoTimer = function () {
        if (this.props.autoPlay) {
            clearTimeout(this.autoTimer);
            this.autoTimer = window.setTimeout(this.nextItem, this.props.transitionTime);
        }
    };
    Carousel.prototype.getChildrenSlides = function () {
        return react_1.Children.toArray(this.props.children).filter(function (child) { return typeof child === 'object' && child.type === Slide_1.default; });
    };
    Carousel.prototype.renderItems = function () {
        var _this = this;
        var nextItem = this.state.counter + 1 < react_1.Children.count(this.props.children) ? this.state.counter + 1 : 0;
        var prevItem = this.state.counter - 1 < 0 ? react_1.Children.count(this.props.children) - 1 : this.state.counter - 1;
        var slides = this.getChildrenSlides();
        return slides.map(function (child, index) { return React.createElement("div", { key: index, className: _this.genSlideClasses(index, nextItem, prevItem) }, child); });
    };
    Carousel.prototype.genSlideClasses = function (index, next, prev) {
        var classes = 'carousel-item ';
        if (index === this.state.counter) {
            classes += ' current';
        }
        if (react_1.Children.count(this.props.children) > 1) {
            if (index === next) {
                classes += ' next';
            }
        }
        return classes;
    };
    Carousel.prototype.setSlide = function (index) {
        this.setState({
            counter: index
        });
    };
    Carousel.prototype.genSliderMarkers = function () {
        var _this = this;
        var slides = this.getChildrenSlides();
        return slides.map(function (child, index) { return React.createElement("li", { className: "slide-marker-item " + (index === _this.state.counter ? ' active' : ''), key: index, onClick: function () { return _this.setSlide(index); } }); });
    };
    Carousel.Slide = Slide_1.default;
    Carousel.defaultProps = {
        height: 400,
        autoPlay: false,
        transitionTime: 5000
    };
    return Carousel;
}(react_1.Component));
exports.default = Carousel;
